/**
 * LV Scroll Reveal - Premium
 * Basliklar soldan, fotograflar sagdan, yazilar asagidan
 * Editor'da calismiyor (intentional)
 */
(function () {
  'use strict';
  if (typeof IntersectionObserver === 'undefined') return;
  if (window.Shopify && window.Shopify.designMode) return;

  var style = document.createElement('style');
  style.textContent = [
    '.lvr-left  { transform:translateX(-36px); opacity:0; transition:transform .8s cubic-bezier(.16,1,.3,1), opacity .65s ease; will-change:transform,opacity; }',
    '.lvr-right { transform:translateX(36px);  opacity:0; transition:transform .8s cubic-bezier(.16,1,.3,1), opacity .65s ease; will-change:transform,opacity; }',
    '.lvr-up    { transform:translateY(28px);  opacity:0; transition:transform .7s cubic-bezier(.16,1,.3,1), opacity .6s ease;  will-change:transform,opacity; }',
    '.lvr-left.lvr-in, .lvr-right.lvr-in, .lvr-up.lvr-in { transform:none; opacity:1; }',
    '@media (prefers-reduced-motion:reduce) { .lvr-left,.lvr-right,.lvr-up { transform:none!important; opacity:1!important; transition:none!important; } }'
  ].join('\n');
  document.head.appendChild(style);

  var rules = [
    /* Basliklar - soldan */
    { sel: '.lv-mat__intro-title',        type: 'left',  delay: 0   },
    { sel: '.lv-mat__eyebrow',            type: 'left',  delay: 0   },
    { sel: '.lv-mat__intro-sub',          type: 'up',    delay: 120 },
    { sel: '.lv-anat__title',             type: 'left',  delay: 0   },
    { sel: '.lv-anat__eyebrow',           type: 'left',  delay: 0   },
    { sel: '.lv-anat__part-desc',         type: 'up',    delay: 80  },
    { sel: '.lv-ls-title',                type: 'left',  delay: 0   },
    { sel: '.lv-ls-overlay-text',         type: 'up',    delay: 60  },
    /* Fotograflar - sagdan */
    { sel: '.lv-ls-img-main',             type: 'right', delay: 0   },
    { sel: '.lv-ls-img-wide',             type: 'right', delay: 60  },
    { sel: '.lv-ls-img-side',             type: 'right', delay: 120 },
    { sel: '.lv-mat__panel-visual',       type: 'right', delay: 0   },
    { sel: '.lvhs-stage',                 type: 'right', delay: 60  },
    { sel: '.lv-hotspot__stage',          type: 'right', delay: 60  },
    /* Sosyal kanit kartlari - asagidan */
    { sel: '.lv-social__card',            type: 'up',    delay: 0   },
    /* Teknik ozellikler - asagidan */
    { sel: '.lv-specs__item',             type: 'up',    delay: 0   },
    /* Lifestyle fotograflari - asagidan */
    { sel: '.lv-lifestyle__item',         type: 'up',    delay: 0   },
    /* Calculator - asagidan */
    { sel: '.lvcalc-result',              type: 'up',    delay: 80  },
    { sel: '.lvcalc-header',              type: 'up',    delay: 0   },
    { sel: '.lvcalc-profiles',            type: 'up',    delay: 60  },
    /* Hotspot header */
    { sel: '.lvhs-hdr',                   type: 'up',    delay: 0   },
    /* SSS */
    { sel: '.lv-faq-header',              type: 'up',    delay: 0   },
    { sel: '.lv-faq-questions',           type: 'left',  delay: 60  },
    { sel: '.lv-faq-answers',             type: 'right', delay: 60  }
  ];

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.dataset.lvrDelay || 0, 10);
      setTimeout(function () { el.classList.add('lvr-in'); }, delay);
      obs.unobserve(el);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });

  function init() {
    rules.forEach(function (rule) {
      document.querySelectorAll(rule.sel).forEach(function (el) {
        if (el.dataset.lvrDone) return;
        el.dataset.lvrDone = '1';
        el.dataset.lvrDelay = rule.delay;
        el.classList.add('lvr-' + rule.type);
        obs.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
